import { render, staticRenderFns } from "./PanoramicaStatusHeader.vue?vue&type=template&id=67ec6384&scoped=true&"
import script from "./PanoramicaStatusHeader.vue?vue&type=script&lang=js&"
export * from "./PanoramicaStatusHeader.vue?vue&type=script&lang=js&"
import style0 from "./PanoramicaStatusHeader.vue?vue&type=style&index=0&id=67ec6384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec6384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ec6384')) {
      api.createRecord('67ec6384', component.options)
    } else {
      api.reload('67ec6384', component.options)
    }
    module.hot.accept("./PanoramicaStatusHeader.vue?vue&type=template&id=67ec6384&scoped=true&", function () {
      api.rerender('67ec6384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PanoramicaStatusHeader.vue"
export default component.exports